import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1254.000000 1254.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1254.000000) scale(0.100000,-0.100000)"
        >
          <path d="M9307 10249 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z" />
          <path d="M9348 10243 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M3520 9996 c0 -18 -254 -1178 -496 -2264 -96 -431 -174 -785 -174
-787 0 -9 187 -79 255 -95 168 -40 433 -50 601 -24 l40 6 97 456 c54 251 101
460 105 464 4 3 336 8 737 9 677 3 734 2 790 -15 146 -43 218 -129 240 -284 4
-34 11 -52 19 -49 221 93 304 129 416 184 119 59 367 190 379 200 3 2 -8 29
-25 59 -57 108 -200 240 -311 289 -24 10 -43 21 -43 26 0 4 17 18 38 30 52 33
158 123 215 183 302 319 386 867 186 1206 -128 218 -361 360 -661 405 -146 22
-2408 22 -2408 1z m2172 -784 c114 -56 153 -128 146 -270 -5 -81 -10 -102 -42
-166 -53 -109 -111 -168 -214 -218 l-85 -43 -704 -3 c-565 -2 -703 0 -703 10
0 7 18 99 40 203 22 105 55 262 73 350 l32 160 125 6 c69 3 382 5 695 5 l570
-1 67 -33z"
          />
          <path
            d="M6836 9345 c2 -11 4 -39 4 -62 l0 -43 180 0 c113 0 180 4 180 10 0 6
-47 10 -120 10 -118 0 -126 2 -121 32 0 4 -17 11 -39 14 -31 5 -40 11 -40 26
0 15 -5 18 -19 13 -12 -3 -21 -1 -24 7 -2 7 -3 4 -1 -7z"
          />
          <path
            d="M8490 9209 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"
          />
          <path
            d="M7550 8230 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"
          />
          <path d="M7919 8203 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z" />
          <path
            d="M7395 8128 c-419 -273 -1090 -639 -1415 -771 -47 -19 -173 -72 -280
-116 -731 -307 -1245 -460 -1835 -548 -173 -25 -613 -26 -738 0 -172 35 -379
121 -442 184 -58 58 -124 165 -140 228 -30 118 -12 256 49 378 19 37 31 67 28
67 -15 0 -94 -120 -133 -199 -55 -111 -69 -167 -69 -274 0 -109 30 -208 95
-312 63 -101 131 -165 258 -243 146 -90 175 -105 277 -135 144 -44 252 -58
470 -64 329 -8 605 28 1089 143 299 70 429 108 651 190 550 201 1007 426 1585
779 358 218 820 538 938 649 23 22 33 32 21 23 -26 -22 -35 -21 -28 1 3 9 -2
5 -10 -10 -9 -15 -37 -43 -63 -63 -51 -39 -72 -40 -28 -2 20 17 24 24 12 24
-9 0 -14 -4 -12 -8 3 -3 -6 -9 -20 -11 -28 -6 -35 8 -7 15 15 4 15 5 0 6 -9 0
-24 -6 -32 -15 -15 -14 -16 -14 -16 0 0 21 -5 20 -41 -6 -23 -17 -34 -20 -46
-12 -33 20 -26 33 16 31 48 -3 51 5 15 38 -28 26 -36 29 -48 18 -3 -4 -15 -8
-26 -10 -10 -1 -34 -12 -52 -23 -37 -22 -53 -26 -42 -9 4 8 -1 9 -17 4 -21 -7
-21 -5 6 16 17 13 32 26 35 30 3 4 21 14 40 22 39 17 91 56 75 57 -5 0 -59
-32 -120 -72z m235 -112 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6 5 11 10
11 6 0 10 -2 10 -4z"
          />
          <path d="M9634 8055 c0 -49 1 -71 3 -48 2 23 2 64 0 90 -2 26 -3 8 -3 -42z" />
          <path
            d="M7415 8110 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path
            d="M7385 8090 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z"
          />
          <path d="M8811 8074 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M8802 8010 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
          <path
            d="M8790 7928 c-1 -32 -33 -148 -68 -243 -56 -155 -173 -342 -286 -458
l-49 -51 2 -71 c2 -78 -8 -114 -127 -430 -114 -304 -162 -415 -217 -505 -59
-95 -186 -237 -255 -285 -22 -15 -39 -29 -38 -31 9 -8 271 53 373 87 211 72
493 221 621 328 18 14 47 37 65 51 19 13 90 81 159 150 173 172 307 356 410
561 43 83 100 217 100 232 0 4 9 26 19 50 25 54 34 86 70 232 29 118 66 344
57 352 -3 3 -7 -17 -11 -44 -4 -26 -13 -73 -21 -103 -8 -30 -16 -70 -18 -87
-1 -18 -6 -36 -11 -40 -4 -5 -5 2 -2 15 3 12 1 22 -4 22 -5 0 -9 -8 -10 -17 0
-10 -3 -13 -5 -6 -3 6 2 28 10 48 21 48 20 55 -4 55 -11 0 -20 -5 -20 -12 0
-16 -49 -58 -66 -58 -8 0 -11 6 -8 15 5 12 -4 15 -45 15 -50 0 -51 -1 -51 -30
0 -28 -2 -30 -40 -30 -22 0 -40 5 -40 10 0 6 -33 10 -80 10 l-80 0 0 30 0 30
-80 0 c-47 0 -80 4 -80 10 0 6 -36 10 -89 10 -62 0 -91 4 -95 13 -3 6 -3 -1 0
-18 4 -23 3 -27 -5 -15 -9 12 -11 9 -12 -15 -1 -19 -3 -23 -6 -11 -6 22 16
106 28 106 4 0 9 -10 11 -22 2 -13 4 21 5 75 2 53 0 97 -2 97 -3 0 -5 -10 -5
-22z m7 -230 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m-12 -28
c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-79
-87 c-8 -15 -15 -25 -16 -21 0 12 23 58 27 54 3 -2 -2 -17 -11 -33z m857 -8
c-3 -9 -8 -14 -10 -11 -3 3 -2 9 2 15 9 16 15 13 8 -4z m-36 -37 c-3 -8 -6 -5
-6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"
          />
          <path
            d="M8800 7830 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5
0 -9 -4 -9 -10z"
          />
          <path
            d="M6927 7258 c-94 -11 -92 -10 -417 -194 -118 -66 -479 -245 -645 -319
-883 -395 -1824 -612 -2457 -567 -264 19 -448 65 -600 151 -49 27 -88 47 -88
44 0 -2 -27 -106 -59 -231 -32 -125 -62 -242 -66 -259 l-7 -33 2394 0 c2663 0
2441 -6 2593 70 152 77 316 242 391 395 36 74 151 372 236 613 56 159 59 206
13 261 -54 63 -55 63 -529 67 -237 2 -489 6 -561 7 -71 2 -161 -1 -198 -5z
m909 -320 c52 -57 48 -95 -30 -281 -35 -83 -89 -215 -121 -292 -63 -157 -108
-215 -199 -260 l-50 -25 -355 0 c-335 0 -358 1 -388 20 -41 24 -66 74 -66 125
1 25 22 91 57 175 31 74 84 204 117 287 69 173 111 231 194 270 l50 23 378 -2
379 -3 34 -37z"
          />
          <path
            d="M7048 6870 c-54 -29 -84 -75 -138 -212 -26 -68 -68 -172 -94 -231
-56 -131 -59 -175 -17 -218 l29 -29 302 0 301 0 45 31 c24 16 51 40 59 53 33
51 215 509 215 542 0 24 -8 43 -25 59 l-24 25 -308 0 c-286 -1 -311 -2 -345
-20z m201 -98 c-24 -71 -20 -92 15 -92 29 0 45 19 26 30 -16 10 -6 88 15 116
11 16 24 18 77 16 35 -2 65 -5 67 -7 1 -2 -8 -29 -22 -60 -22 -46 -31 -56 -57
-61 -34 -7 -42 -34 -10 -34 46 0 77 28 103 92 l25 63 78 7 c103 10 129 -2 128
-57 0 -22 -9 -58 -20 -80 l-19 -40 -98 -3 c-72 -2 -97 -6 -94 -15 2 -8 34 -13
91 -15 48 -1 86 -6 84 -10 -2 -5 -18 -45 -37 -90 l-33 -82 -84 0 c-45 0 -85 3
-87 8 -3 4 6 34 19 66 27 67 30 86 12 86 -7 0 -26 -33 -42 -73 -16 -39 -33
-77 -39 -84 -19 -25 6 -33 104 -33 54 0 99 -2 99 -5 0 -2 -9 -28 -21 -57 -22
-58 -50 -93 -90 -113 -29 -15 -184 -23 -184 -9 0 5 11 37 24 72 25 66 20 92
-20 92 -26 0 -34 -19 -14 -34 16 -11 15 -16 -7 -72 l-23 -59 -73 -3 c-39 -2
-72 -1 -72 2 0 3 12 32 26 65 20 46 33 62 55 70 37 13 38 31 2 31 -41 -1 -59
-19 -94 -98 l-33 -72 -83 0 c-47 0 -93 5 -104 10 -26 15 -24 63 6 128 l24 52
111 0 c91 0 110 3 110 15 0 12 -18 15 -105 15 -58 0 -105 1 -105 3 0 2 15 41
34 88 l34 84 108 5 c73 3 109 9 112 18 3 9 -21 12 -97 12 -74 0 -101 3 -101
13 0 24 48 113 74 137 24 22 39 26 119 30 51 3 95 3 100 -1 4 -3 -2 -33 -14
-67z"
          />
          <path
            d="M4399 5158 c-85 -122 -160 -232 -167 -245 -7 -13 -17 -23 -22 -23 -5
0 -80 108 -167 239 l-158 240 -242 0 c-134 1 -243 -3 -243 -7 0 -4 37 -55 83
-112 90 -115 156 -201 297 -390 52 -69 115 -152 140 -185 74 -95 71 -80 70
-347 l-1 -243 193 0 193 0 3 253 2 254 138 176 c236 303 457 592 460 602 2 6
-75 10 -211 10 l-214 0 -154 -222z"
          />
          <path
            d="M2758 5348 c-8 -13 -54 -104 -103 -203 -48 -99 -177 -358 -285 -576
-109 -218 -207 -418 -218 -443 l-21 -46 205 0 204 0 24 53 c64 141 87 185 102
191 20 8 512 8 551 0 26 -5 36 -20 88 -125 l59 -119 203 0 c112 0 203 4 203 8
0 4 -50 107 -111 227 -61 121 -205 408 -320 638 l-209 417 -179 0 c-174 0
-179 -1 -193 -22z m202 -399 c0 -6 30 -72 66 -147 37 -76 77 -161 90 -189 l24
-53 -190 0 c-105 0 -190 2 -190 4 0 6 41 97 91 204 27 57 49 105 49 107 0 2 9
24 20 50 17 40 40 54 40 24z"
          />
          <path
            d="M5037 5048 c-4 -178 -7 -468 -7 -645 l0 -323 555 0 555 0 0 150 0
150 -360 0 -360 0 0 100 0 100 318 2 317 3 3 143 3 142 -320 0 -321 0 0 100 0
100 348 2 347 3 3 148 3 147 -539 0 -539 0 -6 -322z"
          />
          <path
            d="M890 4710 l0 -640 148 1 c351 1 747 18 810 33 190 48 301 156 318
311 8 77 -7 135 -53 202 -38 57 -124 119 -180 129 -39 7 -42 17 -9 32 45 20
109 86 132 137 31 65 32 161 3 225 -44 97 -143 166 -282 194 -62 13 -151 16
-482 16 l-405 0 0 -640z m734 360 c47 -17 66 -46 66 -98 0 -40 -5 -53 -29 -76
-38 -37 -82 -45 -232 -46 l-126 0 -5 108 c-3 59 -3 110 -1 115 6 11 297 9 327
-3z m25 -479 c57 -11 93 -40 109 -86 18 -55 1 -99 -51 -133 -40 -27 -41 -27
-225 -27 l-185 0 1 110 c1 61 2 118 2 128 0 15 14 17 153 17 83 -1 172 -5 196
-9z"
          />
          <path
            d="M10165 5090 l-90 -6 93 -2 c56 -1 92 2 92 8 0 6 -1 9 -2 8 -2 -1 -43
-5 -93 -8z"
          />
          <path
            d="M11230 4991 c0 -5 5 -13 10 -16 6 -3 10 -2 10 4 0 5 -4 13 -10 16 -5
3 -10 2 -10 -4z"
          />
          <path
            d="M9458 4580 c-4 -201 -7 -398 -6 -437 l1 -73 195 0 195 0 -6 173 c-4
94 -8 267 -8 382 -2 198 -2 204 -10 105 -11 -133 -17 -146 -20 -45 l-2 80 -7
-65 c-4 -38 -7 -50 -8 -30 l-2 35 -90 -3 c-49 -2 -90 -8 -90 -13 0 -5 -9 -9
-19 -9 -11 0 -22 -8 -24 -17 -4 -17 -5 -17 -6 0 -1 19 -30 24 -32 5 -1 -7 -5
-2 -9 12 -6 19 -9 7 -11 -45 l-3 -70 -6 70 -6 70 -4 -85 c-3 -55 -6 -13 -10
120 -5 204 -5 203 -12 -160z"
          />
          <path
            d="M8540 4915 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"
          />
          <path
            d="M8891 4914 c23 -49 46 -90 54 -96 12 -9 -5 -40 -26 -46 -11 -4 -12
-2 -1 9 6 7 12 18 12 23 0 6 -7 0 -16 -12 -22 -32 -37 -27 -19 8 8 16 15 35
15 42 -1 7 -8 -3 -16 -22 -8 -19 -20 -38 -27 -42 -7 -4 -8 -8 -3 -8 5 0 3 -7
-4 -15 -7 -8 -16 -12 -21 -9 -5 3 -9 0 -9 -6 0 -22 -34 -5 -41 20 -5 19 -7 14
-8 -22 -1 -27 -4 -47 -8 -46 -16 4 -52 -23 -59 -44 -6 -21 -7 -21 -20 -3 -16
22 -19 12 -4 -16 21 -38 1 -18 -24 25 -29 50 -33 76 -11 76 8 0 15 5 15 10 0
6 -6 10 -14 10 -8 0 -16 7 -20 15 -3 8 -12 15 -21 15 -12 0 -12 -7 5 -50 11
-28 31 -73 46 -101 14 -28 23 -54 19 -57 -3 -3 -24 -5 -45 -3 -51 3 -88 -7
-69 -20 10 -6 11 -9 2 -9 -7 0 -13 -9 -13 -19 0 -11 -14 -28 -35 -40 -29 -17
-40 -18 -65 -9 -53 18 -65 82 -17 91 12 2 -18 5 -68 5 -75 1 -87 -1 -73 -11 9
-7 19 -31 23 -52 5 -30 4 -36 -4 -25 -10 13 -11 13 -11 0 0 -20 -62 -49 -68
-32 -2 7 -10 12 -17 12 -19 0 -65 47 -65 65 0 8 -9 15 -19 15 -10 0 -21 7 -24
14 -3 8 -22 18 -41 21 l-34 7 -4 65 c-2 35 1 68 7 74 14 14 -9 11 -24 -3 -11
-11 -12 -9 -6 10 3 12 3 22 -2 22 -4 0 -47 -75 -94 -168 -48 -92 -125 -242
-173 -334 l-86 -168 190 0 189 0 18 33 c29 55 83 180 83 193 0 24 50 27 354
20 268 -6 302 -9 311 -24 5 -9 30 -64 55 -122 l46 -105 202 -3 c111 -1 202 0
202 3 0 2 -50 107 -111 232 -61 126 -128 264 -149 308 -73 158 -143 296 -153
302 -5 3 -8 2 -6 -3z m-71 -204 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5
10 10 10 6 0 10 -4 10 -10z m190 -44 c0 -12 -5 -7 -19 24 -11 24 -11 24 3 6 9
-11 16 -24 16 -30z m-1039 -34 c-8 -15 -8 -21 1 -24 8 -3 9 -12 0 -36 -6 -18
-7 -32 -3 -32 5 0 12 11 15 24 5 19 11 22 31 18 16 -3 25 -11 25 -23 0 -12 7
-19 20 -19 17 0 20 -7 20 -40 0 -36 2 -40 26 -40 25 0 26 -2 23 -44 -2 -24 0
-42 4 -39 5 3 18 -5 30 -18 15 -16 17 -21 5 -17 -19 8 -38 -9 -38 -34 0 -11
-5 -15 -15 -12 -9 4 -15 0 -15 -7 0 -11 -3 -11 -10 1 -5 8 -10 20 -10 25 0 6
5 3 10 -5 8 -12 10 -11 10 6 0 11 5 25 11 31 8 8 2 14 -20 24 -18 8 -26 16
-19 20 12 8 -42 69 -61 69 -6 0 -11 12 -11 28 -1 25 -2 26 -15 9 -13 -18 -14
-18 -25 2 -6 12 -7 21 -3 21 4 0 -1 7 -11 15 -11 8 -14 15 -8 15 7 0 12 5 12
11 0 5 -4 7 -10 4 -5 -3 -10 -3 -10 2 0 12 44 93 48 88 2 -2 -1 -12 -7 -23z
m449 -193 c0 -5 -4 -9 -10 -9 -5 0 -10 7 -10 16 0 8 5 12 10 9 6 -3 10 -10 10
-16z m-555 -19 c-3 -5 -12 -10 -18 -10 -7 0 -6 4 3 10 19 12 23 12 15 0z m505
-50 c25 -8 25 -8 -5 -11 -20 -1 -12 -4 25 -9 l55 -7 -63 -1 c-40 -1 -61 2 -57
8 3 6 -4 10 -17 11 -22 0 -22 1 -3 9 24 10 33 10 65 0z m-537 -267 c-7 -2 -19
-2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z"
          />
          <path
            d="M11284 4863 c4 -53 14 -83 26 -83 10 0 1 38 -11 46 -5 3 -9 13 -9 22
1 9 12 -3 25 -28 13 -25 24 -40 25 -34 0 7 -13 37 -30 68 l-29 57 3 -48z"
          />
          <path
            d="M10931 4880 c0 -14 28 -72 29 -59 0 4 -7 22 -15 40 -8 19 -14 27 -14
19z"
          />
          <path
            d="M6671 4745 c-3 -84 -6 -106 -10 -75 -5 37 -7 41 -13 21 -7 -23 -8
-23 -87 -16 -57 5 -81 4 -81 -4 0 -6 -17 -11 -40 -11 -34 0 -40 -3 -41 -22 -1
-19 -2 -20 -6 -5 -7 27 -41 59 -46 44 -2 -7 -8 6 -13 28 -7 37 -8 38 -15 15
-4 -14 -7 -164 -8 -333 l-1 -308 428 3 c410 4 430 5 507 27 159 45 307 144
390 260 70 97 93 168 99 311 5 94 2 88 -10 -20 -5 -50 -7 -53 -20 -35 -8 10
-14 13 -14 7 0 -16 -52 -15 -69 1 -11 10 -14 10 -18 0 -3 -7 -9 -13 -15 -13
-5 0 -23 -13 -40 -30 -23 -23 -38 -30 -70 -30 -30 0 -39 -3 -35 -14 3 -7 0
-13 -6 -13 -18 1 -77 -26 -77 -35 0 -8 -80 -33 -94 -29 -5 1 -13 -4 -17 -11
-5 -8 -9 -9 -9 -2 0 6 9 23 20 37 11 14 20 28 20 32 0 4 -10 -5 -22 -21 -13
-16 -26 -30 -29 -32 -4 -2 -18 -12 -31 -23 -34 -31 -71 -48 -135 -63 -32 -8
-50 -15 -40 -15 9 -1 17 -5 17 -10 0 -12 -37 -21 -80 -20 l-35 1 33 8 c67 16
42 20 -119 20 l-164 0 3 157 c2 87 1 199 -1 248 -3 89 -3 89 -6 -30z m553
-309 c-6 -15 -34 -31 -34 -19 0 5 30 32 37 33 1 0 0 -6 -3 -14z m-49 -36 c-3
-5 -11 -10 -16 -10 -6 0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z m-322
-57 c-18 -2 -48 -2 -65 0 -18 2 -4 4 32 4 36 0 50 -2 33 -4z m5 -20 c-15 -2
-42 -2 -60 0 -18 2 -6 4 27 4 33 0 48 -2 33 -4z m130 0 c-10 -2 -28 -2 -40 0
-13 2 -5 4 17 4 22 1 32 -1 23 -4z"
          />
          <path
            d="M10746 4819 c-9 -23 -15 -43 -13 -46 3 -2 12 15 21 38 9 23 15 43 13
46 -3 2 -12 -15 -21 -38z"
          />
          <path d="M8056 4833 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
          <path d="M7322 4780 c0 -19 2 -27 5 -17 2 9 2 25 0 35 -3 9 -5 1 -5 -18z" />
          <path d="M8025 4779 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
          <path
            d="M8344 4763 c-2 -27 -1 -27 14 3 8 15 8 21 -1 21 -7 0 -13 -11 -13
-24z"
          />
          <path
            d="M10379 4764 c-5 -15 -12 -31 -16 -37 -3 -6 -1 -7 4 -4 11 7 36 67 27
67 -2 0 -9 -12 -15 -26z"
          />
          <path
            d="M10976 4765 c4 -8 8 -15 10 -15 2 0 4 7 4 15 0 8 -4 15 -10 15 -5 0
-7 -7 -4 -15z"
          />
          <path
            d="M11360 4734 c14 -36 14 -36 -26 -19 -20 8 -40 15 -45 15 -16 0 -9
-18 9 -23 9 -3 -16 -5 -55 -6 -50 -1 -73 -5 -73 -13 0 -9 -3 -9 -12 0 -18 18
-65 15 -72 -4 -4 -12 -15 -15 -36 -12 -17 3 -30 3 -30 2 0 -2 11 -28 25 -59
l24 -56 -214 3 c-118 2 -215 0 -215 -4 0 -5 5 -8 11 -8 8 0 8 -4 -1 -15 -6 -8
-9 -19 -5 -25 9 -14 27 -13 20 3 -4 6 3 1 14 -13 27 -33 26 -38 -6 -42 l-27
-3 32 -33 c18 -18 30 -37 27 -42 -3 -5 4 -12 17 -14 13 -3 32 -7 43 -9 11 -3
5 -5 -15 -7 -29 -1 -32 -3 -15 -10 14 -6 5 -9 -35 -9 -35 0 -50 3 -41 8 10 6
6 11 -15 19 -16 6 -23 11 -16 11 6 1 12 12 12 25 0 17 -7 26 -27 32 -16 4 -34
6 -42 5 -7 -1 -11 2 -7 7 6 11 -76 102 -93 102 -20 0 -71 -56 -71 -78 0 -10
-3 -21 -6 -24 -8 -9 -44 3 -38 13 3 5 -4 9 -15 9 -12 0 -21 5 -21 11 0 8 -5 8
-15 -1 -13 -11 -14 -8 -9 21 3 19 7 40 10 47 6 21 -6 13 -16 -10 -6 -17 -9
-19 -9 -6 -1 19 25 79 50 118 15 23 31 70 24 70 -2 0 -42 -77 -90 -171 -47
-94 -90 -178 -95 -187 -13 -24 -140 -282 -140 -285 0 -1 85 -3 189 -4 l188 -2
62 131 62 131 226 -6 c125 -4 270 -7 323 -7 l96 0 52 -114 c29 -62 52 -118 52
-124 0 -5 7 -13 16 -16 18 -7 404 -8 404 -2 0 3 -62 132 -139 288 -76 156
-153 313 -171 351 -32 67 -48 89 -30 41z m-248 -156 l-7 -26 -19 25 c-18 25
-18 25 3 18 14 -4 21 -2 21 6 0 7 2 10 5 8 2 -3 1 -17 -3 -31z m-154 -35 c-10
-2 -18 -11 -18 -19 0 -8 -4 -14 -9 -14 -5 0 -14 -14 -20 -31 -6 -17 -15 -28
-20 -25 -5 3 -11 0 -14 -8 -4 -11 -23 -13 -69 -7 -5 1 -8 10 -8 21 0 13 -7 20
-20 20 -17 0 -20 6 -18 27 2 21 -2 28 -22 34 -14 4 34 7 105 7 72 0 122 -2
113 -5z m-742 -160 c-8 -15 -15 -22 -16 -15 0 17 20 55 27 49 2 -3 -2 -18 -11
-34z m291 -9 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m246 -1
c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m-243 -17 c0 -2 -7 -6
-15 -10 -8 -3 -15 -1 -15 4 0 6 7 10 15 10 8 0 15 -2 15 -4z m-10 -57 c-11
-36 -26 -55 -18 -22 3 12 3 22 -1 21 -18 -2 -22 4 -11 17 23 28 40 18 30 -16z
m-362 -69 c-7 -10 -14 -17 -17 -15 -4 4 18 35 25 35 2 0 -1 -9 -8 -20z"
          />
          <path d="M7702 4720 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
          <path d="M11000 4711 c0 -6 4 -13 10 -16 6 -3 7 1 4 9 -7 18 -14 21 -14 7z" />
          <path
            d="M7326 4675 c-17 -74 -29 -111 -38 -122 -7 -9 -7 -13 0 -13 6 0 19 26
30 58 12 33 21 48 21 35 1 -13 5 -23 10 -23 6 0 7 11 1 28 -5 15 -11 36 -13
47 -3 16 -5 14 -11 -10z"
          />
          <path
            d="M10661 4638 c-13 -26 -19 -33 -16 -18 l5 25 -12 -23 c-8 -17 -8 -26
0 -34 8 -8 17 1 32 37 26 61 20 70 -9 13z"
          />
          <path
            d="M8290 4640 c0 -7 -7 -22 -17 -32 -9 -10 -12 -18 -6 -18 13 0 38 48
30 57 -4 3 -7 0 -7 -7z"
          />
          <path d="M10311 4504 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M2380 3605 l0 -135 25 0 c24 0 25 3 25 55 l0 55 60 0 c57 0 60 1 60
25 0 24 -3 25 -60 25 -60 0 -60 0 -60 30 0 29 0 29 68 32 61 3 67 5 70 26 3
21 1 22 -92 22 l-96 0 0 -135z"
          />
          <path
            d="M2724 3683 c-14 -32 -41 -93 -60 -135 l-33 -78 29 0 c22 0 32 7 42
28 12 24 19 27 70 30 55 3 58 2 73 -28 12 -23 22 -30 45 -30 33 0 38 -17 -43
165 -38 86 -48 100 -71 103 -23 3 -29 -3 -52 -55z m72 -58 c7 -19 14 -39 14
-45 0 -13 -57 -13 -65 0 -6 10 20 80 30 80 3 0 13 -16 21 -35z"
          />
          <path
            d="M3043 3725 c-12 -8 -24 -29 -28 -45 -10 -44 14 -75 75 -95 55 -18 70
-36 50 -60 -16 -19 -43 -19 -80 0 -27 14 -30 14 -40 -6 -9 -17 -8 -23 7 -34
48 -35 148 -21 172 23 30 56 0 103 -78 125 -51 14 -64 39 -31 57 16 8 30 9 53
1 25 -9 34 -8 46 4 15 15 14 18 -3 31 -26 19 -115 18 -143 -1z"
          />
          <path
            d="M3302 3718 c2 -19 10 -24 46 -26 l42 -3 0 -110 0 -109 25 0 25 0 0
109 0 110 43 3 c35 2 43 7 45 26 3 22 2 22 -113 22 -115 0 -116 0 -113 -22z"
          />
          <path
            d="M4040 3605 l0 -135 30 0 c29 0 30 2 30 45 0 41 2 45 25 45 18 0 31
-11 51 -45 21 -37 31 -45 55 -45 16 0 29 2 29 5 0 3 -11 23 -25 45 -30 48 -30
52 -5 67 25 16 36 74 19 104 -21 41 -40 48 -126 49 l-83 0 0 -135z m158 57 c5
-34 -15 -52 -59 -52 -39 0 -39 0 -39 41 l0 40 48 -3 c40 -3 47 -6 50 -26z"
          />
          <path
            d="M4380 3605 l0 -135 101 0 c98 0 100 0 97 23 -3 20 -10 22 -73 27 -67
5 -70 6 -70 30 0 24 3 25 63 28 58 3 62 4 62 27 0 23 -4 24 -62 27 -60 3 -63
4 -66 31 l-3 27 70 0 c69 0 71 1 71 25 0 25 0 25 -95 25 l-95 0 0 -135z"
          />
          <path
            d="M4700 3605 l0 -136 93 3 c84 3 92 5 92 23 0 17 -8 21 -65 25 l-65 5
-3 108 c-3 106 -3 107 -27 107 l-25 0 0 -135z"
          />
          <path d="M5000 3605 l0 -135 25 0 25 0 0 135 0 135 -25 0 -25 0 0 -135z" />
          <path
            d="M5244 3683 c-15 -32 -41 -93 -60 -135 l-33 -78 29 0 c23 0 33 7 45
30 15 30 18 31 73 28 51 -3 58 -6 70 -30 10 -21 20 -28 43 -28 28 0 37 9 23
23 -4 4 -30 60 -58 124 -47 106 -55 118 -79 121 -25 3 -30 -2 -53 -55z m71
-59 c21 -51 20 -54 -20 -54 -19 0 -35 4 -35 9 0 13 29 81 35 81 3 0 12 -16 20
-36z"
          />
          <path
            d="M5540 3605 l0 -135 90 0 c83 0 93 2 115 25 32 31 32 70 0 99 -22 21
-23 25 -10 36 22 19 18 63 -8 88 -20 19 -35 22 -105 22 l-82 0 0 -135z m156
70 c10 -25 -16 -45 -57 -45 -37 0 -39 2 -39 30 0 29 2 30 45 30 32 0 47 -5 51
-15z m-2 -98 c10 -7 17 -22 14 -33 -2 -15 -13 -20 -56 -22 l-52 -3 0 35 c0 35
1 36 38 36 21 0 46 -6 56 -13z"
          />
          <path
            d="M5880 3605 l0 -135 95 0 c95 0 95 0 95 25 0 24 -2 25 -65 25 l-65 0
0 110 0 110 -30 0 -30 0 0 -135z"
          />
          <path
            d="M6180 3605 l0 -135 100 0 100 0 0 25 c0 24 -2 25 -70 25 l-70 0 0 30
0 30 60 0 c57 0 60 1 60 25 0 24 -3 25 -60 25 l-60 0 0 30 0 30 70 0 c68 0 70
1 70 25 l0 25 -100 0 -100 0 0 -135z"
          />
          <path
            d="M6961 3621 c-28 -66 -54 -127 -57 -135 -5 -12 1 -16 24 -16 23 0 31
5 36 25 6 23 10 25 71 25 60 0 66 -2 77 -25 8 -18 19 -25 40 -25 15 0 28 2 28
3 0 2 -26 62 -58 133 -50 113 -61 129 -83 132 -25 3 -30 -5 -78 -117z m97 6
c18 -50 15 -57 -23 -57 -19 0 -35 2 -35 5 0 13 33 85 39 85 4 0 12 -15 19 -33z"
          />
          <path
            d="M7290 3605 l0 -135 24 0 c23 0 25 4 28 52 l3 52 58 -3 c55 -2 57 -2
57 23 0 23 -3 25 -57 28 -57 3 -58 3 -61 36 l-3 32 70 0 c69 0 71 1 71 25 0
25 0 25 -95 25 l-95 0 0 -135z"
          />
          <path
            d="M7596 3724 c-3 -9 -6 -69 -6 -135 l0 -119 30 0 c29 0 30 1 30 50 l0
49 58 3 c50 3 57 6 60 26 3 21 0 22 -57 22 l-61 0 0 35 0 35 65 0 c63 0 65 1
65 25 0 25 -1 25 -89 25 -72 0 -90 -3 -95 -16z"
          />
          <path
            d="M7944 3721 c-47 -29 -64 -59 -64 -115 0 -109 94 -174 194 -132 69 29
103 120 69 186 -38 73 -132 102 -199 61z m131 -56 c56 -55 13 -155 -65 -155
-31 0 -70 42 -76 81 -5 28 -1 41 21 67 34 41 84 44 120 7z"
          />
          <path
            d="M8270 3605 l0 -135 25 0 c23 0 25 4 25 45 0 41 2 45 25 45 19 0 32
-11 55 -48 25 -41 35 -49 60 -49 16 0 30 2 30 4 0 3 -13 24 -30 48 -16 24 -30
47 -30 50 0 4 11 16 25 27 19 14 25 29 25 56 0 68 -37 92 -137 92 l-73 0 0
-135z m150 70 c10 -12 10 -21 2 -40 -10 -21 -18 -25 -57 -25 l-45 0 0 40 0 40
44 0 c27 0 48 -6 56 -15z"
          />
          <path
            d="M8602 3603 l3 -136 74 2 c42 1 88 9 104 17 38 20 71 93 62 137 -17
82 -69 117 -173 117 l-73 0 3 -137z m147 72 c46 -23 55 -88 18 -130 -15 -18
-36 -28 -64 -32 -53 -7 -58 2 -48 102 7 75 7 75 36 75 17 0 43 -7 58 -15z"
          />
          <path
            d="M9014 3674 c-16 -36 -43 -96 -60 -133 -17 -36 -29 -69 -27 -73 10
-19 45 -6 61 22 16 28 21 30 77 30 55 0 61 -2 76 -28 12 -21 23 -28 40 -26 13
1 25 3 26 3 1 1 -25 61 -57 134 -50 114 -61 132 -82 135 -23 3 -29 -5 -54 -64z
m71 -50 c21 -51 20 -54 -20 -54 -19 0 -35 4 -35 9 0 13 29 81 35 81 3 0 12
-16 20 -36z"
          />
          <path
            d="M9310 3601 l0 -141 63 0 c78 0 134 15 147 40 16 30 12 68 -10 90 -19
19 -19 22 -5 36 21 21 19 57 -4 85 -17 21 -29 24 -105 28 l-86 3 0 -141z m145
59 c0 -23 -4 -25 -47 -28 -48 -3 -48 -3 -48 28 0 31 0 31 48 28 43 -3 47 -5
47 -28z m16 -96 c23 -27 -1 -49 -60 -52 l-51 -3 0 35 0 36 49 0 c32 0 53 -5
62 -16z"
          />
          <path
            d="M9650 3600 l0 -141 93 3 c86 3 92 4 95 25 3 21 -1 22 -65 25 l-68 3
-3 113 c-3 112 -3 112 -27 112 l-25 0 0 -140z"
          />
          <path
            d="M9934 3727 c-2 -7 -3 -69 -2 -138 l3 -124 95 0 c90 0 95 1 98 22 3
21 -1 22 -65 25 l-68 3 -3 33 -3 32 60 0 c58 0 61 1 61 25 0 24 -3 25 -60 25
l-60 0 0 30 0 30 70 0 c68 0 70 1 70 25 0 25 0 25 -95 25 -69 0 -97 -4 -101
-13z"
          />
          <path
            d="M897 3596 c-3 -8 -3 -17 0 -20 4 -3 291 -6 640 -6 626 0 633 0 633
20 0 20 -7 20 -634 20 -535 0 -635 -2 -639 -14z"
          />
          <path
            d="M10430 3590 c0 -20 7 -20 610 -20 603 0 610 0 610 20 0 20 -7 20
-610 20 -603 0 -610 0 -610 -20z"
          />
          <path
            d="M3636 3534 c-22 -21 -20 -41 5 -54 24 -14 49 2 49 31 0 28 -35 43
-54 23z m42 -27 c2 -12 -3 -17 -17 -17 -12 0 -21 6 -21 13 0 31 32 34 38 4z"
          />
          <path
            d="M6511 3526 c-9 -11 -10 -20 -1 -35 13 -26 46 -27 59 -3 20 38 -31 71
-58 38z m46 -2 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-17
-24 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"
          />
          <path
            d="M10211 3522 c-11 -21 3 -52 24 -52 26 0 46 29 35 51 -13 24 -46 25
-59 1z m47 -19 c-2 -10 -10 -18 -18 -18 -8 0 -16 8 -18 18 -2 12 3 17 18 17
15 0 20 -5 18 -17z"
          />
          <path
            d="M1470 3119 c-160 -31 -293 -176 -321 -350 -28 -170 71 -349 237 -430
l69 -34 4795 -3 4795 -2 69 21 c120 39 221 135 266 257 18 48 21 73 18 152 -3
81 -9 104 -36 161 -54 112 -168 202 -290 228 -65 14 -9531 14 -9602 0z m414
-161 c13 -19 16 -59 16 -240 0 -275 11 -258 -168 -258 -186 0 -172 -21 -172
260 0 194 2 231 16 244 12 13 41 16 154 16 132 0 140 -1 154 -22z m3856 -5
c-5 -16 -20 -63 -33 -105 l-25 -76 68 -9 68 -8 -136 -143 c-75 -78 -140 -143
-144 -142 -3 0 11 46 33 102 21 56 37 104 35 106 -7 6 -39 10 -89 11 -27 1
-47 5 -45 10 5 13 262 281 270 281 4 0 3 -12 -2 -27z m2855 -13 c22 -22 44
-40 49 -40 4 0 30 18 56 40 72 60 99 52 35 -10 -19 -19 -35 -38 -35 -42 0 -4
38 -8 85 -8 75 0 85 -2 95 -21 15 -27 9 -274 -6 -289 -11 -11 -59 -18 -121
-19 -18 -1 -33 -5 -33 -10 0 -6 15 -11 33 -13 20 -2 32 -8 32 -18 0 -12 -23
-15 -138 -18 -128 -2 -138 -1 -135 15 2 10 13 19 26 21 44 7 20 20 -43 24 -36
2 -70 9 -75 14 -17 17 -18 290 -2 306 9 9 40 12 98 11 46 -2 84 1 84 6 0 5
-16 21 -35 37 -35 28 -46 54 -22 54 6 -1 30 -19 52 -40z m-5205 -226 c0 -156
-4 -244 -10 -244 -6 0 -10 90 -10 251 0 164 3 248 10 244 6 -4 10 -98 10 -251z
m1810 6 c0 -160 -4 -250 -10 -250 -6 0 -10 90 -10 250 0 160 4 250 10 250 6 0
10 -90 10 -250z m2972 -4 c-2 -156 -6 -245 -12 -241 -11 7 -14 477 -4 488 4 4
10 5 13 3 3 -2 5 -115 3 -250z m-4179 194 c57 -21 137 -83 137 -105 0 -7 -6
-18 -14 -24 -11 -10 -21 -6 -48 17 -77 67 -187 97 -273 73 -34 -9 -97 -45
-152 -86 -9 -7 -18 -4 -30 7 -16 17 -16 19 8 44 59 63 178 107 266 99 29 -3
77 -14 106 -25z m-1736 -175 c17 -50 32 -96 32 -102 1 -21 -36 -15 -42 7 -4
16 -14 20 -45 20 -31 0 -41 -4 -45 -20 -3 -12 -14 -20 -25 -20 -20 0 -20 2 8
84 54 160 70 164 117 31z m93 -10 c0 -98 -1 -105 -20 -105 -19 0 -20 7 -20 98
0 100 3 112 27 112 10 0 13 -24 13 -105z m150 85 c24 -24 26 -57 4 -88 -14
-21 -14 -26 0 -56 20 -43 20 -46 -2 -46 -12 0 -25 14 -37 40 -10 22 -24 40
-32 40 -9 0 -13 -13 -13 -40 0 -33 -3 -40 -20 -40 -19 0 -20 7 -20 98 0 54 3
102 7 105 15 16 93 7 113 -13z m175 0 c0 -8 -11 -17 -25 -20 -24 -6 -25 -10
-28 -88 -3 -74 -5 -82 -22 -82 -18 0 -20 7 -20 85 0 84 0 85 -25 85 -19 0 -25
5 -25 20 0 19 5 21 73 18 55 -2 72 -6 72 -18z m56 8 c-1 -5 -1 -51 -1 -103 0
-89 -1 -95 -21 -95 -19 0 -20 5 -18 98 1 53 4 101 6 105 6 10 34 5 34 -5z
m105 -43 c10 -31 22 -54 28 -52 5 2 17 25 26 53 14 41 21 50 43 52 l27 3 0
-105 c0 -99 -1 -106 -20 -106 -18 0 -20 7 -20 61 0 69 -11 70 -30 4 -16 -57
-38 -57 -60 2 -18 50 -36 70 -26 30 9 -38 -3 -97 -20 -97 -11 0 -14 21 -14 98
0 54 3 102 7 105 3 4 14 7 24 7 13 0 23 -15 35 -55z m282 33 c3 -13 -6 -17
-40 -20 -35 -2 -43 -7 -43 -23 0 -16 8 -21 38 -23 29 -3 37 -7 35 -20 -2 -12
-14 -17 -38 -17 -28 0 -36 -4 -38 -22 -3 -19 2 -22 40 -25 31 -2 44 -8 46 -20
3 -16 -5 -18 -62 -18 l-66 0 0 98 c0 54 3 102 7 106 4 4 32 6 63 4 42 -2 56
-7 58 -20z m1297 -8 c20 -19 25 -33 25 -73 0 -40 -5 -53 -29 -78 -24 -24 -38
-29 -75 -29 l-46 0 0 106 0 107 50 -5 c34 -4 59 -13 75 -28z m182 -65 c17 -50
32 -96 32 -102 1 -21 -37 -15 -44 7 -5 15 -15 20 -45 20 -29 0 -39 -4 -43 -20
-3 -12 -14 -20 -27 -20 -16 0 -20 4 -16 16 3 8 18 50 32 92 46 134 65 136 111
7z m173 75 c0 -15 -7 -20 -25 -20 -25 0 -25 -1 -25 -85 0 -78 -2 -85 -20 -85
-18 0 -20 7 -20 85 0 84 0 85 -25 85 -24 0 -34 18 -18 33 3 4 35 7 70 7 56 0
63 -2 63 -20z m152 -85 c21 -55 38 -101 38 -102 0 -2 -10 -3 -23 -3 -14 0 -26
9 -32 23 -14 31 -62 31 -82 0 -9 -13 -24 -23 -34 -23 -17 0 -16 7 12 88 17 48
35 95 41 105 20 38 42 13 80 -88z m1176 98 c30 -7 46 -47 31 -75 -8 -14 -8
-23 0 -31 17 -17 13 -68 -6 -83 -10 -7 -42 -14 -70 -14 l-53 0 0 98 c0 54 3
102 7 105 8 9 60 9 91 0z m102 -98 c0 -84 -3 -105 -14 -105 -20 0 -27 44 -22
130 3 41 6 76 6 78 0 1 7 2 15 2 12 0 15 -18 15 -105z m70 20 l0 -85 40 0 c33
0 40 -3 40 -20 0 -18 -7 -20 -60 -20 l-60 0 0 98 c0 100 3 112 27 112 10 0 13
-21 13 -85z m140 0 l0 -85 40 0 c33 0 40 -3 40 -20 0 -18 -7 -20 -60 -20 l-60
0 0 98 c0 100 3 112 27 112 10 0 13 -21 13 -85z m206 71 c24 -18 12 -31 -29
-31 -45 0 -41 -25 5 -47 58 -27 61 -89 7 -118 -41 -22 -116 13 -85 39 11 9 20
10 36 1 16 -9 25 -8 36 1 21 17 17 28 -13 40 -42 16 -63 39 -63 70 0 49 63 76
106 45z m239 -11 c14 -13 25 -33 25 -45 0 -29 -44 -70 -75 -70 -22 0 -25 -4
-25 -35 0 -28 -4 -35 -20 -35 -19 0 -20 7 -20 105 l0 105 45 0 c35 0 52 -6 70
-25z m132 13 c10 -13 73 -178 73 -191 0 -16 -42 -5 -47 12 -3 13 -16 20 -40
23 -29 4 -37 0 -46 -19 -5 -13 -18 -23 -29 -23 -10 0 -18 2 -18 4 0 3 14 44
31 93 31 87 44 113 59 113 4 0 12 -6 17 -12z m120 -30 l20 -43 22 43 c20 39
38 51 54 35 4 -3 -6 -30 -23 -60 -21 -37 -30 -66 -30 -98 0 -38 -3 -45 -20
-45 -17 0 -20 7 -20 43 0 28 -10 58 -30 92 -34 58 -37 75 -12 75 11 0 26 -16
39 -42z m190 -23 c21 -59 21 -60 32 -32 6 15 14 39 17 52 8 31 29 49 49 41 12
-4 15 -25 15 -106 0 -93 -1 -100 -20 -100 -18 0 -20 7 -21 63 l0 62 -20 -53
c-27 -68 -39 -65 -73 18 l-14 35 -1 -62 c-1 -56 -3 -63 -21 -63 -19 0 -20 7
-20 98 0 54 3 102 7 106 4 4 16 6 28 4 15 -2 26 -19 42 -63z m271 43 c3 -13
-6 -17 -40 -20 -36 -2 -44 -7 -46 -25 -3 -21 1 -23 38 -23 34 0 41 -3 38 -17
-2 -12 -13 -18 -33 -19 -45 -3 -45 -3 -45 -24 0 -17 7 -20 45 -20 38 0 45 -3
45 -20 0 -18 -7 -20 -65 -20 l-65 0 0 98 c0 54 3 102 7 106 4 4 32 6 63 4 42
-2 56 -7 58 -20z m92 -25 c16 -26 33 -56 37 -67 6 -15 10 -1 13 44 4 49 9 65
20 65 12 0 16 -19 18 -103 3 -103 3 -103 -20 -100 -16 2 -32 20 -53 60 -16 32
-33 58 -37 58 -5 0 -8 -27 -8 -60 0 -53 -2 -60 -20 -60 -19 0 -20 7 -20 98 0
54 3 102 7 105 16 16 35 4 63 -40z m258 25 c2 -12 -5 -17 -25 -20 -28 -3 -28
-3 -31 -85 -3 -75 -5 -83 -22 -83 -18 0 -20 7 -20 85 0 84 0 85 -25 85 -19 0
-25 5 -25 20 0 19 5 21 72 18 59 -2 73 -6 76 -20z m1652 0 c0 -5 0 -13 0 -19
0 -6 -14 -9 -32 -7 -46 4 -45 -26 2 -50 31 -15 35 -21 35 -57 0 -34 -4 -42
-28 -53 -22 -10 -35 -11 -62 -2 -37 12 -42 19 -23 38 8 8 17 8 30 1 11 -6 26
-8 34 -5 25 10 15 35 -21 50 -86 36 -55 136 37 117 16 -3 29 -9 28 -13z m465
12 c36 -14 26 -35 -16 -35 -50 0 -51 -28 0 -49 27 -10 43 -24 47 -40 16 -65
-68 -108 -124 -63 -22 17 5 38 33 25 31 -14 62 6 44 28 -6 8 -18 14 -25 14
-24 0 -54 39 -54 70 0 22 7 33 28 44 33 18 34 19 67 6z m188 -7 c4 -2 7 -11 7
-20 0 -12 -7 -14 -35 -10 -39 6 -61 -9 -71 -48 -13 -52 26 -96 67 -75 27 15
56 -5 38 -26 -12 -14 -75 -19 -104 -8 -44 17 -59 114 -24 158 32 41 80 52 122
29z m752 5 c75 -34 71 -170 -6 -197 -41 -14 -95 8 -109 44 -24 62 -4 130 45
151 38 17 38 17 70 2z m-6985 -34 c60 -33 79 -59 58 -81 -13 -12 -22 -9 -67
22 -45 30 -61 35 -110 35 -55 0 -131 -26 -145 -49 -4 -6 -16 -11 -27 -11 -26
0 -25 31 4 57 75 69 190 80 287 27z m5272 -28 c10 -33 20 -62 22 -64 3 -2 13
25 23 59 16 53 23 65 42 67 17 3 22 0 19 -10 -3 -7 -18 -52 -34 -100 -24 -74
-32 -88 -49 -88 -18 0 -26 15 -52 91 -17 50 -34 86 -38 80 -3 -6 -17 -11 -31
-11 -23 0 -24 -2 -24 -80 0 -73 -2 -80 -20 -80 -18 0 -20 7 -20 80 0 79 0 80
-25 80 -18 0 -25 5 -25 20 0 20 5 21 97 18 l97 -3 18 -59z m378 -5 c0 -50 4
-74 16 -85 34 -35 52 -10 56 79 2 57 6 70 21 73 15 3 17 -6 17 -81 0 -99 -15
-122 -78 -120 -56 2 -72 28 -72 124 0 72 2 79 20 79 18 0 20 -7 20 -69z m265
45 c13 -20 14 -29 5 -46 -9 -16 -9 -25 -1 -33 16 -16 13 -63 -5 -81 -10 -11
-34 -16 -70 -16 l-54 0 0 100 0 100 55 0 c47 0 57 -3 70 -24z m469 2 c21 -29
20 -57 -1 -80 -15 -17 -15 -21 0 -54 21 -43 21 -44 -1 -44 -12 0 -25 14 -37
40 -10 22 -24 40 -32 40 -9 0 -13 -13 -13 -40 0 -33 -3 -40 -20 -40 -19 0 -20
7 -20 100 l0 100 54 0 c45 0 58 -4 70 -22z m76 -79 c0 -90 -2 -100 -17 -97
-16 3 -18 15 -16 98 1 52 2 96 2 98 1 1 8 2 16 2 12 0 15 -18 15 -101z m152
84 c23 -21 24 -75 1 -96 -10 -8 -31 -17 -48 -19 -26 -3 -30 -8 -33 -35 -2 -21
-9 -33 -18 -33 -9 0 -14 11 -14 33 0 17 -3 62 -7 100 l-6 67 53 0 c36 0 60 -6
72 -17z m168 -3 c0 -15 -7 -20 -25 -20 -25 0 -25 -1 -25 -80 0 -73 -2 -80 -20
-80 -18 0 -20 7 -20 80 0 79 0 80 -25 80 -18 0 -25 5 -25 20 0 18 7 20 70 20
63 0 70 -2 70 -20z m55 -65 c8 -92 4 -115 -20 -115 -12 0 -15 17 -15 100 0 79
3 100 14 100 11 0 16 -22 21 -85z m307 23 l33 -62 3 62 c3 54 6 62 22 62 19 0
20 -7 20 -100 0 -97 -1 -100 -23 -100 -17 0 -30 14 -57 63 l-35 62 -3 -62 c-3
-55 -6 -63 -22 -63 -19 0 -20 7 -20 100 0 99 0 100 24 100 20 0 31 -12 58 -62z
m-7221 -58 c19 -6 45 -20 57 -33 20 -21 20 -25 8 -43 -14 -19 -15 -19 -38 4
-30 27 -97 30 -138 5 -24 -14 -31 -14 -45 -3 -14 12 -14 15 2 33 21 23 69 46
98 47 11 0 36 -5 56 -10z m-13 -112 c28 -28 7 -78 -33 -78 -27 0 -45 18 -45
45 0 12 5 26 12 33 7 7 21 12 33 12 12 0 26 -5 33 -12z"
          />
          <path
            d="M1696 2951 c-3 -5 10 -11 30 -13 34 -4 50 3 37 16 -10 9 -61 7 -67
-3z"
          />
          <path
            d="M1645 2911 l-50 -6 -3 -169 c-2 -111 1 -173 8 -180 7 -7 60 -11 135
-11 l125 0 0 181 0 181 -52 7 c-58 6 -87 6 -163 -3z"
          />
          <path
            d="M1692 2508 c7 -20 68 -23 68 -4 0 12 -10 16 -36 16 -24 0 -34 -4 -32
-12z"
          />
          <path d="M8450 2720 l0 -120 195 0 195 0 0 120 0 120 -195 0 -195 0 0 -120z" />
          <path
            d="M8590 2540 c0 -5 20 -10 45 -10 25 0 45 5 45 10 0 6 -20 10 -45 10
-25 0 -45 -4 -45 -10z"
          />
          <path
            d="M2191 2737 c-14 -37 -14 -37 9 -37 21 0 24 12 10 45 -7 19 -9 18 -19
-8z"
          />
          <path
            d="M2420 2766 c0 -31 14 -40 40 -26 29 16 21 44 -13 48 -23 3 -27 0 -27
-22z"
          />
          <path
            d="M4327 2783 c-4 -3 -7 -33 -7 -65 0 -55 1 -58 24 -58 34 0 56 25 56
65 0 43 -49 82 -73 58z"
          />
          <path
            d="M4531 2737 c-14 -37 -14 -37 9 -37 21 0 24 12 10 45 -7 19 -9 18 -19
-8z"
          />
          <path
            d="M4851 2737 c-14 -37 -14 -37 9 -37 21 0 27 24 10 50 -7 11 -11 9 -19
-13z"
          />
          <path
            d="M6047 2783 c-4 -3 -7 -15 -7 -25 0 -23 32 -24 51 -2 10 13 10 17 -2
25 -17 10 -33 11 -42 2z"
          />
          <path
            d="M6047 2704 c-10 -11 -9 -42 3 -49 20 -12 51 6 48 28 -3 22 -36 35
-51 21z"
          />
          <path
            d="M6780 2760 c0 -25 4 -30 24 -30 28 0 42 26 25 46 -6 8 -20 14 -30 14
-14 0 -19 -7 -19 -30z"
          />
          <path
            d="M6956 2738 c-9 -35 -8 -38 15 -38 15 0 19 4 15 16 -3 9 -6 22 -6 30
0 22 -17 16 -24 -8z"
          />
          <path
            d="M10912 2774 c-16 -11 -22 -25 -22 -54 0 -29 6 -43 22 -54 12 -9 26
-16 30 -16 19 0 48 43 48 70 0 27 -29 70 -48 70 -4 0 -18 -7 -30 -16z"
          />
          <path
            d="M9820 2760 c0 -21 24 -27 49 -11 19 12 4 31 -25 31 -17 0 -24 -5 -24
-20z"
          />
          <path
            d="M9820 2675 c0 -20 4 -24 23 -21 12 3 25 5 30 5 4 1 7 10 7 21 0 16
-7 20 -30 20 -25 0 -30 -4 -30 -25z"
          />
          <path
            d="M10292 2758 c3 -25 25 -33 47 -19 21 14 5 41 -24 41 -22 0 -26 -4
-23 -22z"
          />
          <path
            d="M10520 2756 c0 -31 8 -36 38 -25 13 5 22 17 22 29 0 16 -7 20 -30 20
-25 0 -30 -4 -30 -24z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
